import { Button } from '@mantine/core';

export const AvailableLibraryList = () => {
  return (
    <div className="mb-3 text-sm text-gray-700 dark:text-gray-300">
      <a
        href="https://fakerjs.dev"
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 hover:underline"
      >
        Faker.js
      </a>
      <a
        href="https://playwright.dev"
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 hover:underline"
      >
        Playwright
      </a>
      <a
        href="https://docs.sheetjs.com"
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 hover:underline"
      >
        XLSX (SheetJS)
      </a>
      <a
        href="https://nodejs.org/en/learn/getting-started/fetch"
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 hover:underline"
      >
        Fetch (Node.js)
      </a>
      <a
        href="https://www.npmjs.com/package/officeparser"
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 hover:underline"
      >
        OfficeParser
      </a>
      <Button
        component="a"
        variant="default"
        href="mailto:help@stably.ai?subject=Library Request"
        size="compact-sm"
        className="mt-2"
      >
        Request More
      </Button>
    </div>
  );
};
